import { bool, elementType, exact, objectOf, string } from 'prop-types';

export const IconType = exact({
  Icon: elementType.isRequired,
  category: string.isRequired,
  collectible: bool.isRequired,
  color: string.isRequired,
  id: string.isRequired,
  label: string.isRequired,
  order: string.isRequired,
});

export const IconsType = objectOf(IconType);
